import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { authClient } from "@/lib/auth-client";
import { getSafeRedirectTarget, isConsumerSession } from "@/lib/auth-roles";

export function PublicRoute({ children }: { children: ReactNode }) {
  const { data, isPending } = authClient.useSession();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const isConsumerAuthRoute = location.pathname.startsWith("/auth/consumer");
  const redirectPath =
    isConsumerAuthRoute && isConsumerSession(data)
      ? getSafeRedirectTarget(searchParams.get("next"), "/account")
      : isConsumerSession(data)
        ? "/account"
        : "/";

  useEffect(() => {
    if (!isPending && data) {
      navigate(redirectPath);
    }
  }, [data, isPending, navigate, redirectPath]);

  if (isPending) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!data) {
    return <>{children}</>;
  }

  return null;
}
